export class NonImmutableValue extends Error {
    constructor() {
        super();

        Error.captureStackTrace(this, this.constructor);

        this.name = 'NonImmutableValue';
        this.message = "Given state isn't a immutable state";
    }
}
